<script setup>
import { computed } from '#imports';

const props = defineProps({
  title: {
    type: String,
    default: 'Другие материалы',
  },
  articles: {
    type: Array,
    required: true,
  },
});

const articleTypesTemplate = [
  {
    size: 'big',
    isFullImage: true,
    titleColor: '#FFF7FB',
    subtitleColor: '#FFF4FA',
    shadowColor: '#101010',
  },
  {
    size: 'small',
    isFullImage: false,
    titleColor: '#000000',
    subtitleColor: '#0E0E0E',
  },
  {
    size: 'small',
    isFullImage: true,
    titleColor: '#FFF7FB',
    subtitleColor: '#FFF4FA',
    shadowColor: '#101010',
  },
  {
    size: 'small',
    isFullImage: false,
    titleColor: '#000000',
    subtitleColor: '#0E0E0E',
  },
  {
    size: 'small',
    isFullImage: false,
    titleColor: '#000000',
    subtitleColor: '#0E0E0E',
  },
];

const preparedArticles = computed(() =>
  props.articles.map((item, index) => ({
    ...item,
    size: articleTypesTemplate[index]?.size || 'small',
    isFullImage: articleTypesTemplate[index]?.isFullImage || false,
    titleColor: articleTypesTemplate[index]?.titleColor || '#FFF7FB',
    subtitleColor: articleTypesTemplate[index]?.subtitleColor || '#FFF4FA',
    shadowColor: articleTypesTemplate[index]?.shadowColor || '#101010',
  }))
);
</script>

<template>
  <div class="other-articles">
    <div class="content-container">
      <div class="other-articles__title">{{ title }}</div>
      <div class="other-articles__grid">
        <div
          v-for="article in preparedArticles"
          :key="article._id"
          class="other-articles__grid-item"
          :class="{
            'other-articles__grid-item--small': article.size === 'small',
            'other-articles__grid-item--big': article.size === 'big',
          }"
        >
          <a
            v-if="article.isArticleExternalSourceType"
            :href="article.externalSource"
            target="_blank"
          >
            <PostCardArticle
              :post="article"
              :with-border="!article.isFullImage"
            />
          </a>
          <NuxtLink
            v-else
            :to="{
              name: 'articles-slug',
              params: { slug: article.slug.current },
            }"
          >
            <PostCardArticle
              :post="article"
              :with-border="!article.isFullImage"
            />
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.other-articles {
  padding-bottom: 120px;

  &__title {
    margin-bottom: 16px;
    font-size: 18px;
    line-height: 22px;
    color: rgba(var(--black-color--rgb), 40%);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-flow: dense;
    gap: 24px;

    @media (--tablet-vp) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__grid-item {
    &--small {
      grid-column-end: span 1;
      grid-row-end: span 2;
    }

    &--big {
      grid-column-end: span 2;
      grid-row-end: span 4;
    }
  }

  @media (--large-vp) {
    &__grid {
      gap: 20px;
    }
  }

  @media (--small-vp) {
    padding-bottom: 60px;

    &__title {
      margin-bottom: 8px;
      padding-right: 6px;
      font-size: 14px;
      line-height: 20px;
    }

    &__grid {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
}
</style>
